import type React from 'react'
import styles from './LoadingPage.module.scss'

const LOGO_URL = 'https://cdn.fercdn.net/logo-s.png'

export type LoadingBrandProps = {
  /** Status label under the brand mark. */
  title?: string
  /** Thin indeterminate bar — default true. */
  showProgress?: boolean
  /**
   * `page` — full boot loading.
   * `overlay` — compact mark for in-panel overlays (theme preview).
   */
  size?: 'page' | 'overlay'
}

/**
 * Shared Fordeer loading mark (logo + ring spinner + progress).
 * Used by LoadingPage and ThemeBuilder preview overlay.
 */
export const LoadingBrand: React.FC<LoadingBrandProps> = ({
  title,
  showProgress = true,
  size = 'page',
}) => {
  const isOverlay = size === 'overlay'
  const logoSize = isOverlay ? 32 : 40

  return (
    <div
      className={[styles.stage, isOverlay ? styles.stageOverlay : '']
        .filter(Boolean)
        .join(' ')}
    >
      <div
        className={[styles.brand, isOverlay ? styles.brandOverlay : '']
          .filter(Boolean)
          .join(' ')}
      >
        <span className={styles.spinner} aria-hidden="true" />
        <img
          src={LOGO_URL}
          alt=""
          className={[styles.logo, isOverlay ? styles.logoOverlay : '']
            .filter(Boolean)
            .join(' ')}
          width={logoSize}
          height={logoSize}
          decoding="async"
        />
      </div>

      {title ? <p className={styles.title}>{title}</p> : null}

      {showProgress ? (
        <div
          className={[
            styles.progressTrack,
            isOverlay ? styles.progressTrackOverlay : '',
          ]
            .filter(Boolean)
            .join(' ')}
          aria-hidden="true"
        >
          <span className={styles.progressBar} />
        </div>
      ) : null}
    </div>
  )
}
